/* AURA11 Shopify Theme — theme.js */

document.addEventListener('DOMContentLoaded', function () {

  // ─── Fade-in on scroll (IntersectionObserver) ─────────────
  const fadeEls = document.querySelectorAll('.fade-in');
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.12, rootMargin: '0px 0px -40px 0px' }
  );
  fadeEls.forEach((el) => observer.observe(el));

  // ─── Mobile menu ──────────────────────────────────────────
  const hamburger = document.querySelector('.site-nav__hamburger');
  const mobileMenu = document.querySelector('.mobile-menu');
  const menuClose = document.querySelector('.mobile-menu__close');

  if (hamburger && mobileMenu) {
    hamburger.addEventListener('click', () => mobileMenu.classList.add('open'));
    menuClose.addEventListener('click', () => mobileMenu.classList.remove('open'));
    mobileMenu.querySelectorAll('a').forEach((link) => {
      link.addEventListener('click', () => mobileMenu.classList.remove('open'));
    });
  }

  // ─── Cart drawer ──────────────────────────────────────────
  const cartDrawer = document.querySelector('.cart-drawer');
  const cartOverlay = document.querySelector('.cart-drawer__overlay');
  const cartClose = document.querySelector('.cart-drawer__close');
  const cartIcon = document.querySelector('.site-nav__cart');

  function openCart() {
    if (cartDrawer) { cartDrawer.classList.add('open'); cartOverlay.classList.add('open'); }
    renderCart();
  }
  function closeCart() {
    if (cartDrawer) { cartDrawer.classList.remove('open'); cartOverlay.classList.remove('open'); }
  }

  if (cartIcon) cartIcon.addEventListener('click', openCart);
  if (cartClose) cartClose.addEventListener('click', closeCart);
  if (cartOverlay) cartOverlay.addEventListener('click', closeCart);

  function renderCart() {
    fetch('/cart.js')
      .then((r) => r.json())
      .then((cart) => {
        updateCartCount(cart.item_count);
        const itemsEl = document.querySelector('.cart-drawer__items');
        const totalEl = document.querySelector('.cart-drawer__total-price');
        if (!itemsEl) return;

        if (cart.item_count === 0) {
          itemsEl.innerHTML = '<p class="cart-drawer__empty">Je winkelwagen is leeg.</p>';
        } else {
          itemsEl.innerHTML = cart.items.map((item) => `
            <div class="cart-item" data-key="${item.key}">
              <img src="${item.image}" alt="${item.product_title}" />
              <div class="cart-item__info">
                <div class="cart-item__title">${item.product_title}</div>
                <div class="cart-item__price">${formatMoney(item.price)}</div>
                <div class="cart-item__qty">
                  <button class="qty-btn qty-minus" data-key="${item.key}" data-qty="${item.quantity - 1}">−</button>
                  <span>${item.quantity}</span>
                  <button class="qty-btn qty-plus" data-key="${item.key}" data-qty="${item.quantity + 1}">+</button>
                </div>
              </div>
            </div>
          `).join('');

          // qty buttons
          itemsEl.querySelectorAll('.qty-btn').forEach((btn) => {
            btn.addEventListener('click', function () {
              updateLineItem(this.dataset.key, parseInt(this.dataset.qty));
            });
          });
        }

        if (totalEl) totalEl.textContent = formatMoney(cart.total_price);
      });
  }

  function updateLineItem(key, qty) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty }),
    })
      .then((r) => r.json())
      .then(() => renderCart());
  }

  function updateCartCount(count) {
    const countEl = document.querySelector('.site-nav__cart-count');
    if (countEl) {
      countEl.textContent = count;
      countEl.style.display = count > 0 ? 'flex' : 'none';
    }
  }

  function formatMoney(cents) {
    return '€' + (cents / 100).toFixed(2).replace('.', ',');
  }

  // Initial cart count
  fetch('/cart.js').then((r) => r.json()).then((c) => updateCartCount(c.item_count));

  // ─── Add to cart (drankje section) ───────────────────────
  document.querySelectorAll('.add-to-cart-btn').forEach((btn) => {
    const originalHTML = btn.innerHTML;
    btn.addEventListener('click', function () {
      const variantId = this.dataset.variantId;
      const qty = parseInt(this.dataset.qty) || 1;
      if (!variantId) return;

      btn.disabled = true;
      btn.textContent = 'Even geduld…';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: parseInt(variantId), quantity: qty }),
      })
        .then((r) => r.json())
        .then((data) => {
          if (data.status && data.status !== 200) throw new Error(data.description || 'Error');
          renderCart();
          openCart();
          setTimeout(() => {
            btn.disabled = false;
            btn.innerHTML = originalHTML;
          }, 1500);
        })
        .catch(() => {
          btn.disabled = false;
          btn.innerHTML = originalHTML;
          btn.style.outline = '2px solid red';
          setTimeout(() => { btn.style.outline = ''; }, 2000);
        });
    });
  });

  // ─── Ingredients modal ────────────────────────────────────
  const modalOverlay = document.querySelector('.modal-overlay');
  const modalBox = document.querySelector('.modal-box');
  const ingredientsLink = document.querySelector('.drankje-ingredients-link');
  const modalCloseBtn = document.querySelector('.modal-close');

  if (ingredientsLink && modalOverlay) {
    ingredientsLink.addEventListener('click', () => modalOverlay.classList.add('open'));
    modalCloseBtn.addEventListener('click', () => modalOverlay.classList.remove('open'));
    modalOverlay.addEventListener('click', (e) => {
      if (!modalBox.contains(e.target)) modalOverlay.classList.remove('open');
    });
  }

  // ─── Testimonials carousel ────────────────────────────────
  const quotes = document.querySelectorAll('.ervaringen-quote-slide');
  const prevBtn = document.querySelector('.ervaringen-nav__prev');
  const nextBtn = document.querySelector('.ervaringen-nav__next');
  const counter = document.querySelector('.ervaringen-nav__counter');
  let activeIdx = 0;

  function collapseReadMore(slide) {
    const rest = slide.querySelector('.review-rest');
    const btn  = slide.querySelector('.review-read-more');
    if (!rest || !btn) return;
    rest.style.display = 'none';
    btn.textContent = 'Lees meer ↓';
    btn.setAttribute('aria-expanded', 'false');
  }

  function showSlide(idx) {
    quotes.forEach((q, i) => {
      q.style.display = i === idx ? 'block' : 'none';
      if (i !== idx) collapseReadMore(q);
    });
    if (counter) counter.textContent = `${idx + 1} / ${quotes.length}`;
    activeIdx = idx;
  }

  if (quotes.length > 0) {
    showSlide(0);
    if (prevBtn) prevBtn.addEventListener('click', () => showSlide((activeIdx - 1 + quotes.length) % quotes.length));
    if (nextBtn) nextBtn.addEventListener('click', () => showSlide((activeIdx + 1) % quotes.length));
  }

  // ─── Read-more toggle ─────────────────────────────────────
  document.querySelectorAll('.review-read-more').forEach(function(btn) {
    btn.addEventListener('click', function(e) {
      e.stopPropagation();
      const slide = btn.closest('.ervaringen-quote-slide');
      const rest  = slide.querySelector('.review-rest');
      if (!rest) return;
      const isExpanded = btn.getAttribute('aria-expanded') === 'true';
      if (isExpanded) {
        rest.style.display = 'none';
        btn.textContent = 'Lees meer ↓';
        btn.setAttribute('aria-expanded', 'false');
      } else {
        rest.style.display = 'inline';
        btn.textContent = 'Lees minder ↑';
        btn.setAttribute('aria-expanded', 'true');
      }
    });
  });

  // ─── FAQ accordion ────────────────────────────────────────
  document.querySelectorAll('.faq-item').forEach((item) => {
    const btn = item.querySelector('.faq-question');
    const answer = item.querySelector('.faq-answer');
    if (!btn || !answer) return;

    btn.addEventListener('click', function () {
      const isOpen = item.classList.contains('open');
      // close all
      document.querySelectorAll('.faq-item.open').forEach((openItem) => {
        openItem.classList.remove('open');
        openItem.querySelector('.faq-answer').style.maxHeight = '0';
      });
      if (!isOpen) {
        item.classList.add('open');
        answer.style.maxHeight = answer.scrollHeight + 'px';
      }
    });
  });

  // ─── Hero bubbles (dynamic) ───────────────────────────────
  const bubblesContainer = document.querySelector('.hero-section__bubbles');
  if (bubblesContainer) {
    for (let i = 0; i < 35; i++) {
      const size = Math.random() * 10 + 3;
      const bubble = document.createElement('span');
      bubble.classList.add('hero-section__bubble', 'bubble-rise');
      bubble.style.left = `${Math.random() * 100}%`;
      bubble.style.width = `${size}px`;
      bubble.style.height = `${size}px`;
      bubble.style.bottom = '-20px';
      bubble.style.animationDelay = `${Math.random() * 20}s`;
      bubble.style.animationDuration = `${Math.random() * 14 + 16}s`;
      bubble.style.opacity = Math.random() * 0.35 + 0.08;
      bubble.style.background = 'radial-gradient(circle at 30% 25%, rgba(251,250,248,0.9), rgba(211,165,34,0.3))';
      bubble.style.border = '1px solid rgba(211,165,34,0.5)';
      bubble.style.boxShadow = 'inset 0 0 4px rgba(211,165,34,0.2)';
      bubblesContainer.appendChild(bubble);
    }
  }

  // ─── Hero info-bubbels (klikbaar, tonen info) ────────────
  const infoBubbleData = [
    {
      label: 'Cafeïnevrij',
      info: 'Geen cafeïne,\ngeen crash.\nHelderheid zonder piek.'
    },
    {
      label: 'Alcoholvrij',
      info: '0% alcohol.\nJij blijft scherp\nen volledig aanwezig.'
    },
    {
      label: 'Saffraan',
      info: '150.000 bloemen\nper kilo — met de hand\ngeoogst in Khorasan.'
    },
    {
      label: 'AURA11',
      info: '12 kcal · 100% natuurlijk.\nEen moment\nvoor jezelf.'
    }
  ];

  // Info-bubbels gaan in de hero-section zelf (niet de bubbles-container)
  // zodat ze boven de hero-content liggen en altijd klikbaar zijn
  const heroSection = document.querySelector('.hero-section');

  // Bijhouden welke horizontale posities (left%) momenteel bezet zijn
  // zodat bubbels elkaar nooit raken (88px breed, minimale gap 24%)
  const activeInfoBubbles = [];

  function findFreeLeft() {
    var minGap = 24; // procent — 88px op ~390px viewport ≈ 22.5%; 24% = veilige marge
    var range  = 76; // beschikbaar bereik: 12 t/m 88%
    var left;
    var tries  = 0;
    do {
      left = 12 + Math.random() * range;
      tries++;
    } while (
      tries < 40 &&
      activeInfoBubbles.some(function (b) { return Math.abs(b - left) < minGap; })
    );
    return left;
  }

  function spawnInfoBubble(data, delay) {
    setTimeout(function () {
      var left = findFreeLeft();
      activeInfoBubbles.push(left);

      const wrap = document.createElement('div');
      wrap.className = 'hero-bubble-info';
      wrap.style.left = left + '%';
      wrap.style.bottom = '-100px';
      wrap.style.animationDuration = '28s';
      wrap.style.animationDelay = '0s';

      const labelEl = document.createElement('span');
      labelEl.className = 'hero-bubble-info__label';
      labelEl.textContent = data.label;

      const tip = document.createElement('div');
      tip.className = 'hero-bubble-info__tooltip';
      tip.textContent = data.info;

      wrap.appendChild(labelEl);
      wrap.appendChild(tip);
      heroSection.appendChild(wrap);

      let opened = false;

      function releaseSlot() {
        var idx = activeInfoBubbles.indexOf(left);
        if (idx > -1) activeInfoBubbles.splice(idx, 1);
      }

      // Na 28s is de bubbel bovenaan: zacht vervagen en verwijderen
      const removeTimer = setTimeout(function () {
        if (!opened) {
          releaseSlot();
          wrap.classList.add('is-fading');
          setTimeout(function () {
            wrap.remove();
            spawnInfoBubble(data, 2000 + Math.random() * 3000);
          }, 700);
        }
      }, 28000);

      function openBubble(e) {
        e.preventDefault();
        e.stopPropagation();
        if (opened) return;
        opened = true;
        clearTimeout(removeTimer);
        releaseSlot(); // geef de positie vrij zodat volgende bubbel kan spawnen
        wrap.classList.add('is-open');
        setTimeout(function () {
          wrap.classList.add('is-fading');
          setTimeout(function () {
            wrap.remove();
            spawnInfoBubble(data, 3000 + Math.random() * 4000);
          }, 700);
        }, 5000);
      }
      wrap.addEventListener('click', openBubble);
      wrap.addEventListener('touchend', openBubble, { passive: false });
    }, delay);
  }

  if (heroSection) {
    infoBubbleData.forEach(function (data, i) {
      spawnInfoBubble(data, 2500 + i * 3500);
    });
  }

  // ─── Ingredient hotspots (drankje-sectie) ───────────────
  const hotspots = document.querySelectorAll('.drankje-hotspot');

  function closeAllHotspots(except) {
    hotspots.forEach(function (h) {
      if (h !== except) h.classList.remove('is-active');
    });
  }

  hotspots.forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      const isOpen = btn.classList.contains('is-active');
      closeAllHotspots(null);
      if (!isOpen) btn.classList.add('is-active');
    });
    btn.addEventListener('touchend', function (e) {
      e.preventDefault();
      e.stopPropagation();
      const isOpen = btn.classList.contains('is-active');
      closeAllHotspots(null);
      if (!isOpen) btn.classList.add('is-active');
    }, { passive: false });
  });

  // Klik buiten hotspot sluit alles
  document.addEventListener('click', function () { closeAllHotspots(null); });
  document.addEventListener('touchend', function () { closeAllHotspots(null); });

  // ─── Scroll-to anchor (hero CTAs) ───────────────────────
  document.querySelectorAll('.hero-cta-scroll').forEach((btn) => {
    btn.addEventListener('click', () => {
      const target = document.querySelector('#shop');
      if (target) {
        const y = target.getBoundingClientRect().top + window.scrollY - 16;
        window.scrollTo({ top: y, behavior: 'smooth' });
      }
    });
  });

  // ─── Countdown timer ─────────────────────────────────────
  const cdTarget = new Date('2026-08-20T00:00:00');
  const cdDays  = document.getElementById('cd-days');
  const cdHours = document.getElementById('cd-hours');
  const cdMins  = document.getElementById('cd-mins');
  const cdSecs  = document.getElementById('cd-secs');

  function updateCountdown() {
    const diff = cdTarget - Date.now();
    if (diff <= 0) {
      if (cdDays)  cdDays.textContent  = '00';
      if (cdHours) cdHours.textContent = '00';
      if (cdMins)  cdMins.textContent  = '00';
      if (cdSecs)  cdSecs.textContent  = '00';
      return;
    }
    const d = Math.floor(diff / 86400000);
    const h = Math.floor((diff % 86400000) / 3600000);
    const m = Math.floor((diff % 3600000)  / 60000);
    const s = Math.floor((diff % 60000)    / 1000);
    if (cdDays)  cdDays.textContent  = String(d).padStart(2, '0');
    if (cdHours) cdHours.textContent = String(h).padStart(2, '0');
    if (cdMins)  cdMins.textContent  = String(m).padStart(2, '0');
    if (cdSecs)  cdSecs.textContent  = String(s).padStart(2, '0');
  }

  if (cdDays) {
    updateCountdown();
    setInterval(updateCountdown, 1000);
  }

  // ─── Email popup (30s delay, eenmalig per sessie) ─────
  const popup       = document.getElementById('aura-popup');
  const popupClose  = document.getElementById('popup-close');
  const popupLater  = document.getElementById('popup-later');
  const popupForm   = document.getElementById('popup-form');
  const popupSuccess= document.getElementById('popup-success');

  function openPopup() {
    if (!popup) return;
    popup.classList.add('active');
    popup.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  function closePopup() {
    if (!popup) return;
    popup.classList.remove('active');
    popup.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    sessionStorage.setItem('aura11_popup_seen', '1');
  }

  if (popup && !sessionStorage.getItem('aura11_popup_seen')) {
    setTimeout(openPopup, 30000);
  }

  if (popupClose) popupClose.addEventListener('click', closePopup);
  if (popupLater) popupLater.addEventListener('click', closePopup);

  if (popup) {
    popup.addEventListener('click', (e) => {
      if (e.target === popup) closePopup();
    });
  }

  // ─── Email subscribe helper ───────────────────────────
  const SUBSCRIBE_URL = window.__aura11SubscribeUrl__ || '';

  function subscribeEmail(email, source, onSuccess, onError, name) {
    if (!SUBSCRIBE_URL) { onSuccess && onSuccess(); return; }
    fetch(SUBSCRIBE_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email, source, name: name || '' }),
    })
      .then((r) => { if (!r.ok) throw new Error(); onSuccess && onSuccess(); })
      .catch(() => { onError && onError(); });
  }

  if (popupForm) {
    popupForm.addEventListener('submit', (e) => {
      e.preventDefault();
      const email = document.getElementById('popup-email').value.trim();
      if (!email) return;
      const cta = popupForm.querySelector('.popup-cta');
      const input = popupForm.querySelector('.popup-input');
      cta.disabled = true;
      cta.textContent = '…';
      subscribeEmail(email, 'popup',
        () => {
          cta.style.display = 'none';
          input.style.display = 'none';
          if (popupSuccess) popupSuccess.style.display = 'block';
          // copy-knop
          const copyBtn = document.getElementById('popup-copy-btn');
          if (copyBtn) {
            copyBtn.addEventListener('click', function () {
              navigator.clipboard.writeText('AURA11').then(() => {
                copyBtn.classList.add('copied');
                setTimeout(() => copyBtn.classList.remove('copied'), 2000);
              });
            });
          }
          setTimeout(closePopup, 8000);
        },
        () => {
          cta.disabled = false;
          cta.textContent = 'ONTVANG MIJN 11%';
        }
      );
    });
  }

  // ─── Waitlist form (subscribe) ────────────────────────
  const waitlistFormEl = document.querySelector('.waitlist-form');
  if (waitlistFormEl) {
    waitlistFormEl.addEventListener('submit', function (e) {
      e.preventDefault();
      const emailInput = this.querySelector('input[type="email"]');
      const nameInput  = this.querySelector('input[type="text"]');
      const btn = this.querySelector('button[type="submit"]');
      const email = emailInput ? emailInput.value.trim() : '';
      const name  = nameInput  ? nameInput.value.trim()  : '';
      if (!email) return;
      btn.textContent = 'Even geduld…';
      btn.disabled = true;
      subscribeEmail(email, 'waitlist',
        () => showWaitlistSuccess(),
        () => showWaitlistSuccess(),
        name
      );
    });

    function showWaitlistSuccess() {
      waitlistFormEl.style.display = 'none';
      const success = document.querySelector('.waitlist-success');
      if (success) success.style.display = 'block';
    }
  }

  // ─── Thee pagina aanmeldbalk ──────────────────────────
  const theeForm = document.getElementById('thee-signup-form');
  if (theeForm) {
    theeForm.addEventListener('submit', function (e) {
      e.preventDefault();
      const email = document.getElementById('thee-signup-email').value.trim();
      if (!email) return;
      const btn = theeForm.querySelector('.thee-signup__btn');
      btn.disabled = true;
      btn.textContent = '…';
      subscribeEmail(email, 'thee-ritueel',
        () => {
          theeForm.style.display = 'none';
          const success = document.getElementById('thee-signup-success');
          if (success) success.style.display = 'block';
        },
        () => {
          btn.disabled = false;
          btn.textContent = 'Meld mij aan';
        }
      );
    });
  }

  // ─── AURA11 Tea pagina aanmeldbalk ────────────────────
  const teaForm = document.getElementById('tea-signup-form');
  if (teaForm) {
    teaForm.addEventListener('submit', function (e) {
      e.preventDefault();
      const email = document.getElementById('tea-signup-email').value.trim();
      if (!email) return;
      const btn = teaForm.querySelector('.thee-signup__btn');
      btn.disabled = true;
      btn.textContent = '…';
      subscribeEmail(email, 'aura11-tea',
        () => {
          teaForm.style.display = 'none';
          const success = document.getElementById('tea-signup-success');
          if (success) success.style.display = 'block';
        },
        () => {
          btn.disabled = false;
          btn.textContent = 'Houd mij op de hoogte';
        }
      );
    });
  }

  // ─── Intro loader ─────────────────────────────────────
  const introEl = document.getElementById('aura11-intro');
  if (introEl && !sessionStorage.getItem('aura11_intro_seen')) {
    sessionStorage.setItem('aura11_intro_seen', '1');
    document.body.style.overflow = 'hidden';
    setTimeout(() => {
      introEl.classList.add('aura11-intro--out');
      setTimeout(() => {
        introEl.style.display = 'none';
        document.body.style.overflow = '';
      }, 800);
    }, 3000);
  } else if (introEl) {
    introEl.style.display = 'none';
  }

});
